import React, { useEffect, useState } from 'react';
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TablePagination from "@material-ui/core/TablePagination";
import Paper from "@material-ui/core/Paper";
import axios from 'axios';
const root_string = require("../../../config.json")["root_string"];

const useStyles = makeStyles({
  table: {
    minWidth: 650
  }
});

export default function PaginatedV1ExpiredOptionsTable() {
  const classes = useStyles();
  const [data, setData] = React.useState({rows: []});
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(5);
  
  useEffect( () => {
    (async () => {
      const res = await axios
        .get(root_string + '/api/data_api/V1_expired_options')
        .catch(err => {
          console.log('Error from V1 Expired options');
        });
      setData(
        {
          rows: res.data["data"].sort(function(op1, op2) {
              return (op2['expiry'] - op1['expiry']);
          })
        }
      );
    })();
  }, []);
  
  const getEtherscan = (token_address) => {
    return 'https://etherscan.io/token/' + token_address;
  };
  
  const getDateString = (unix) => {
    let date_object = new Date(unix * 1000);
    return date_object.toLocaleDateString();
  };
  
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  
  const handleChangeRowsPerPage = event => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const emptyRows =
    rowsPerPage - Math.min(rowsPerPage, data.rows.length - page * rowsPerPage);
  
  function print_int(num) {
    try {
      num = parseInt(num);
      return num;
    } catch (e) {
      return "Unknown"
    }
  }
  
  
  function addCommasTicks(value) {
    try {
      value = value.toFixed(2);
      if (Math.abs(value) >= 1000){
        return '$' + value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return '$' + value;
      }
    } catch (e) {
        return NaN;
    }
  }
  
  function print_thousands(num) {
    try {
      num = num / 1000;
      num = num.toFixed(1);
      return num;
    } catch (e) {
      return "Unknown"
    }
  }
  
  function get_name(name) {
    if (name === "") {
      return "Unknown Name";
    } else {
      return name;
    }
  }
  console.log(page * rowsPerPage, page * rowsPerPage + rowsPerPage);
  return (
    <TableContainer component={Paper}>
      <Table className={classes.table} aria-label='simple table'>
        <TableHead>
          <TableRow>
            <TableCell>Expired Options</TableCell>
            <TableCell align='right'>Expiry</TableCell>
            <TableCell align='right'>Holders</TableCell>
            <TableCell align='right'>Minters</TableCell>
            {/*<TableCell align='right'>Amount Minted</TableCell>*/}
            
            <TableCell align='right'>Premium Traded ($k)</TableCell>
            <TableCell align='right'>Volume Traded ($k)</TableCell>

            {/*<TableCell align='right'>Volume Traded ($k)</TableCell>*/}
            {/*<TableCell align='right'>Avg. Daily Volume ($k)</TableCell>*/}
            
            <TableCell align='right'>Days Active</TableCell>
            <TableCell align='right'>Trades</TableCell>
            
            <TableCell align='right'>Expired ITM</TableCell>
            <TableCell align='right'>ITM Amount</TableCell>
          
          </TableRow>
        </TableHead>
        <TableBody>
          {data.rows
            .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
            .map((option, index) => (
              <TableRow key={get_name(option.address)}>
                <TableCell component='th' scope='row'>
                  <a href={getEtherscan(option.address)}>{get_name(option.opyn_name)}</a>
                </TableCell>
                <TableCell align='right'>{getDateString(option.expiry)}</TableCell>
                <TableCell align='right'>{option.n_holders}</TableCell>
                <TableCell align='right'>{option.n_minters}</TableCell>
                {/*<TableCell align='right'>{option.amount_minted}</TableCell>*/}
                
                <TableCell align='right'>${print_thousands(option.total_premium)}</TableCell>
                <TableCell align='right'>${print_thousands(option.total_volume)}</TableCell>

                {/*<TableCell align='right'>${print_thousands(option.total_volume)}</TableCell>*/}
                {/*<TableCell align='right'>${print_thousands(option.volumes_per_day)}</TableCell>*/}
                
                <TableCell align='right'>{print_int(option.duration)}</TableCell>
                <TableCell align='right'>{print_int(option.n_txns)}</TableCell>
                
                <TableCell align='right'>{option.ITM_bool.toString()}</TableCell>
                <TableCell align='right'>{addCommasTicks(option.ITM_amount)}</TableCell>
              
              </TableRow>
            ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 48 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
      </Table>
      <TablePagination
        rowsPerPageOptions={[2, 5, 10]}
        component='div'
        count={data.rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />
    </TableContainer>
  );
}
